export default class Loader {
  toggle: boolean
  endFn: (() => void) | null

  constructor(config: { endFn?: () => void | null }) {
    this.toggle = false
    this.endFn = config.endFn || null

    // イベント
    window.addEventListener('load', () => this.loadedEvent())
    setTimeout(() => {
      if (!this.toggle) this.loadEnd()
      window.removeEventListener('load', () => this.loadedEvent())
    }, 5000)
  }

  loadedEvent() {
    setTimeout(() => {
      if (this.toggle) return
      this.loadEnd()
    }, 250)
  }

  loadEnd() {
    this.toggle = true

    if (document.body.id === 'preload') {
      document.body.removeAttribute('id')
    }
    const loaderItem = document.getElementById('loader')
    loaderItem?.classList.add('loadOp')

    // hashがあった際の処理
    const hash = location.hash
    if (hash) {
      const target = document.querySelector(hash)
      const clientRect = target?.getBoundingClientRect()
      if (!clientRect) return
      const y = window.scrollY + clientRect.y
      window.scrollTo({
        top: y,
        behavior: 'instant',
      })
    }

    setTimeout(() => {
      if (loaderItem) loaderItem.classList.add('loadend')

      if (this.endFn) this.endFn()
    }, 1000)
  }
}
